'use strict';
var parent = require('../actual/parse-int');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/full/parse-int.js
// module id = 638
// module chunks = 13